<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body">
  <table class="table table-bordered custom-table">
    <thead style="text-align: center">
      <tr>
        <th>Account Code</th>
        <th>Counterparty</th>
        <th>Account Description</th>
        <th>Current Year Amount</th>
        <th>Prior Year Amount</th>
        <th>Variance Amount</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>111601133</td>
        <td></td>
        <td>FMV-Asset-Internal_IRS</td>
        <td class="text-right">6,696,030</td>
        <td class="text-right">0</td>
        <td class="text-right">6,696,030</td>
      </tr>
      <tr>
        <td>111601133</td>
        <td></td>
        <td>FMV-Asset-Internal_IRS</td>
        <td class="text-right">1</td>
        <td class="text-right">6,696,030</td>
        <td class="text-right">-6,696,030</td>
      </tr>
    </tbody>
    <thead>
      <tr>
        <th>Total Assests</th>
        <th></th>
        <th></th>
        <th class="text-right">6,696,030</th>
        <th class="text-right">305,929,286</th>
        <th class="text-right">-299,929,286</th>
      </tr>
    </thead>
    <tbody>
      @for (item of trailData; track $index) {
<tr>
        <td>{{item.ac_code}}</td>
        <td></td>
        <td>{{item.des}}</td>
        <td class="text-right">{{item.curr_amt}}</td>
        <td class="text-right">{{item.prior_amt}}</td>
        <td class="text-right">{{item.var_amt}}</td>
      </tr>
}
    </tbody>
  </table>
</div>
